import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { PROFIT_LOSS_EVENT_NAME } from './constants';
import { Tracker } from '../Tracker';

var TAB_NAMES = {
  transactionsHistory: 'My Transactions',
  transactionsSummary: 'P&L Summary',
  transactionsHistoryDateRangePanel: 'My Transactions',
  transactionsSummaryDateRangePanel: 'P&L Summary'
};

var FILTER_OPTIONS_NAMES = {
  monthToDate: 'Month to date',
  last7days: 'Last 7 days',
  DAYS_7: 'Last 7 days',
  DAYS_14: 'Last 14 days',
  DAYS_30: 'Last 30 days',
  last12months: 'Last 12 months',
  CUSTOM: 'Custom range',
  ALL: 'All dates'
};

var TAB_TO_PANELS = {
  transactionsSummary: {
    panel: 'transactionsSummaryDateRangePanel',
    defaultValue: FILTER_OPTIONS_NAMES.monthToDate
  },
  transactionsHistory: {
    panel: 'transactionsHistoryDateRangePanel',
    defaultValue: FILTER_OPTIONS_NAMES.last7days
  }
};

var profitValue = function profitValue(monthToDateData) {
  if (monthToDateData.value === 0) {
    return 'No Gain';
  }
  if (monthToDateData.isProfit) {
    return 'Profit';
  }
  return 'Loss';
};

var getPreviousFilterDateRangeType = function getPreviousFilterDateRangeType(filtersState, previousTab) {
  var previousPanel = TAB_TO_PANELS[previousTab].panel;

  var previousRange = TAB_TO_PANELS[previousTab].defaultValue;
  if (filtersState[previousPanel]) {
    previousRange = FILTER_OPTIONS_NAMES[filtersState[previousPanel].fields.predefinedDateRange.value] || filtersState[previousPanel].fields.predefinedDateRange.value;
  }
  return previousRange;
};

export var ProfitAndLossTracker = function (_Tracker) {
  _inherits(ProfitAndLossTracker, _Tracker);

  function ProfitAndLossTracker() {
    _classCallCheck(this, ProfitAndLossTracker);

    return _possibleConstructorReturn(this, (ProfitAndLossTracker.__proto__ || _Object$getPrototypeOf(ProfitAndLossTracker)).apply(this, arguments));
  }

  _createClass(ProfitAndLossTracker, [{
    key: 'onItemClicked',
    value: function onItemClicked(monthToDateData) {
      this.publishPartialEvent(PROFIT_LOSS_EVENT_NAME, {
        EventCategory: 'Safer Gambling Interactions',
        EventAction: 'My Transactions',
        EventLabel: 'Profit and Loss Summary',
        ElementType: 'Account Menu',
        ProfitOrLoss: profitValue(monthToDateData),
        DateRangeType: FILTER_OPTIONS_NAMES.monthToDate
      });
    }
  }, {
    key: 'onTabChanged',
    value: function onTabChanged(filtersState, activeTab, monthToDateData) {
      var previousTab = activeTab === 'transactionsSummary' ? 'transactionsHistory' : 'transactionsSummary';
      var dateRangeType = getPreviousFilterDateRangeType(filtersState, previousTab);
      this.publishPartialEvent(PROFIT_LOSS_EVENT_NAME, {
        SiteSectionCategory: 'Category Selection',
        EventCategory: 'Safer Gambling Interactions',
        EventAction: 'My Transactions',
        EventLabel: 'Tab change - ' + (TAB_NAMES[activeTab] || activeTab),
        ElementType: TAB_NAMES[previousTab] || previousTab,
        ProfitOrLoss: profitValue(monthToDateData),
        DateRangeType: dateRangeType
      });
    }
  }, {
    key: 'onSGLinkClicked',
    value: function onSGLinkClicked(monthToDateData, filterDateRange) {
      this.publishPartialEvent(PROFIT_LOSS_EVENT_NAME, {
        SiteSectionCategory: 'Category Selection',
        EventCategory: 'Safer Gambling Interactions',
        EventAction: 'My Transactions',
        EventLabel: 'Safer Gambling Tools Click',
        ElementType: TAB_NAMES.transactionsSummary,
        ProfitOrLoss: profitValue(monthToDateData),
        DateRangeType: FILTER_OPTIONS_NAMES[filterDateRange] || filterDateRange
      });
    }
  }, {
    key: 'onFilterChangeApplied',
    value: function onFilterChangeApplied(activeTab, filter, monthToDateData) {
      var profitDanLossEventData = {
        SiteSectionCategory: 'Category Selection',
        EventCategory: 'Safer Gambling Interactions',
        EventAction: 'My Transactions',
        EventLabel: 'Date Range Change Applied',
        ElementType: TAB_NAMES[activeTab] || activeTab,
        DateRangeType: FILTER_OPTIONS_NAMES[filter] || filter
      };
      if (monthToDateData) {
        profitDanLossEventData.ProfitOrLoss = profitValue(monthToDateData);
      }
      this.publishPartialEvent(PROFIT_LOSS_EVENT_NAME, profitDanLossEventData);
    }
  }]);

  return ProfitAndLossTracker;
}(Tracker);